import {loadScript} from 'netlify-cms-lib-util';

const SIGNATURE_URL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:9000/cloudinary' : '/.netlify/functions/cloudinary';

let _mediaLibrary;
let _insertHandler = (...args) => console.error('No openMediaLibrary callback defined', ...args);

const enforcedConfig = {
  button_class: undefined,
  inline_container: undefined,
  insert_transformation: false,
  z_index: '99999',
};

const defaultConfig = {
  multiple: true,
  max_files: 100,
};

export async function initMediaLibrary() {
  if (_mediaLibrary) return _mediaLibrary;

  await Promise.all([
    loadScript('https://identity-js.netlify.com/v1/netlify-identity-widget.js'),
    loadScript('https://media-library.cloudinary.com/global/all.js'),
  ]);

  const signature = await getSignature();
  const config = {...defaultConfig, ...enforcedConfig, ...signature};

  _mediaLibrary = global.cloudinary.createMediaLibrary(config, {
    insertHandler: data => {
      _insertHandler(data.assets.map(assetToObject));
    },
  });

  return _mediaLibrary;
}

export function openMediaLibrary(callback, config = {}) {
  if (callback == null) throw new Error('openMediaLibrary requires a callback as the first argument');
  _insertHandler = callback;
  return _mediaLibrary.show({...defaultConfig, ...config});
}

function getUser() {
  const user = global.netlifyIdentity.currentUser();

  return new Promise((resolve, reject) => {
    if (user != null) {
      resolve(user);
    } else {
      global.netlifyIdentity.on('init', user => {
        if (user != null) {
          resolve(user);
        } else {
          global.netlifyIdentity.on('login', resolve);
        }
      });
    }
  });
}

function assetToObject(asset) {
  return {width: asset.width, height: asset.height, cloudinaryId: asset.public_id};
}

async function getSignature() {
  const user = await getUser();
  const signatureResponse = await fetch(SIGNATURE_URL, {
    headers: {Authorization: `Bearer ${user.token.access_token}`},
  });
  return await signatureResponse.json();
}
